import { ShopRendererThemesApiClient } from '@fourthwall/services/dist/ShopRendererThemesApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useInstalledThemesQuery = createQueryHook(
  ShopRendererThemesApiClient.getInstalledThemes,
  {
    queryKey: ['installedThemes'],
  },
)
